import React, { ChangeEvent, useRef } from 'react';
import IBookmark from '~/src/types/IBookmark';
import { parseFile } from '~/src/service/file-service';
import Button from '../elements/button/Button';

interface Props {
  className: string;
  bookmarks: IBookmark[];
  onBookmarksImport: (bookmarks: IBookmark[]) => void;
}

export const ImportExport: React.FC<Props> = ({
  className,
  bookmarks,
  onBookmarksImport,
}) => {
  const inputFile = useRef(null);

  const importBookmarks = () => {
    inputFile.current.click();
  };

  const importFile = async (e: ChangeEvent) => {
    if (!(e.target instanceof HTMLInputElement)) return;

    const filesList = e.target.files;
    if (filesList.length > 0) {
      try {
        onBookmarksImport(await parseFile(filesList[0]));
      } catch (err) {
        console.error(err);
        alert('Bookmarks file is invalid or corrupt!');
      }
    }
  };

  const exportBookmarks = () => {
    const file = new Blob([JSON.stringify(bookmarks)], { type: 'text/plain' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(file);
    link.download = 'bookmarks.pb';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className={className}>
      <Button small className="mr-1" onClick={importBookmarks}>
        <span className="icon is-small">
          <i className="material-icons is-size-6">cloud_upload</i>
        </span>
        <span>IMPORT</span>
        <input
          type="file"
          ref={inputFile}
          onChange={importFile}
          style={{ display: 'none' }}
        />
      </Button>
      <Button small onClick={exportBookmarks}>
        <span className="icon is-small">
          <i className="material-icons is-size-6">cloud_download</i>
        </span>
        <span>EXPORT</span>
      </Button>
    </div>
  );
};
